var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'is-frame-mode': _vm.isFrameMode,
  }},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"legacy-app"}},[_c('div',{attrs:{"ui-view":""}})])
}]

export { render, staticRenderFns }